module.exports = __webpack_public_path__ + "static/media/menu-ios-white.aab99537.svg";